<template>

  <div class="loading">
    <span>{{displaytext}}</span>
    <div class="inner">
      <img src="/static/img/icons/brain.svg" />
    </div>
  </div>

</template>

<script>
  export default {
    props: ['text'],
    computed: {
      displaytext() {
        if (this.text) return this.text;
        return 'Loading...';
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .loading { text-align: center; }
    .loading span { font-size: 18px; color: #4285f4 ;}
    .loading .inner { text-align: center; width: 200px; margin: 0px auto; border-radius: 50%; background: #FFFFFF; padding: 20px; margin-top:10px;}
  .loading img { width: 100%; display: block; animation: pulse ease-in-out 1s infinite alternate; }
  @keyframes pulse {
    0% { width:70%;margin:15%; }
    100% { width:100%; }
  }
</style>



// WEBPACK FOOTER //
// LoadingIndicator.vue?3a213e51